import {Alert, Stack, Text} from '@mantine/core';
import {IconAlertTriangle} from '@tabler/icons-react';
import {Button} from 'src/design/atoms/Button';

export interface TreeBrowserUnavailableAlertProps {
  itemName: string;
  resetLabel: string;
  onReset: () => void;
}

/**
 * Warning and reset action for a selected tree node that is absent from the current tree.
 * @registry Yellow missing-tree-selection alert with a subtle reset action.
 */
export const TreeBrowserUnavailableAlert = ({
  itemName,
  resetLabel,
  onReset,
}: TreeBrowserUnavailableAlertProps) => (
  <Alert
    color="yellow"
    variant="light"
    title="Selection unavailable"
    icon={<IconAlertTriangle size={16} />}>
    <Stack gap="xs">
      <Text size="sm">
        The selected {itemName} is not available in this tree.
      </Text>
      <Button variant="subtle" size="xs" onClick={onReset}>
        {resetLabel}
      </Button>
    </Stack>
  </Alert>
);
